module.exports = "/_next/static/images/image@4x-c1958fcf9668219c80039a5cf46de73a.png";